var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconComplete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__icon_complete",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_7202",
    "data-name": "Group 7202",
    transform: "translate(-769 -300)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_7087",
    "data-name": "Group 7087",
    transform: "translate(168 137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Ellipse_35",
    fill: "#1e561f",
    stroke: "#fff",
    "data-name": "Ellipse 35",
    transform: "translate(601 163)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_7090",
    "data-name": "Group 7090",
    transform: "translate(192.296 39.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__check",
    fill: "#fcfff5",
    d: "M3.274 72.145L.141 69.012a.482.482 0 0 1 0-.682l.682-.682a.482.482 0 0 1 .682 0l2.11 2.11 4.52-4.52a.482.482 0 0 1 .682 0l.682.682a.482.482 0 0 1 0 .682l-5.543 5.543a.482.482 0 0 1-.682 0z",
    transform: "translate(579.698 200.3)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComplete);
export default __webpack_public_path__ + "static/media/icon-complete.e65a6d32bde261b999f6d2f9698d3e0d.svg";
export { ForwardRef as ReactComponent };